import { render, staticRenderFns } from "./CreateStoryButton.vue?vue&type=template&id=4e9d2de8"
import script from "./CreateStoryButton.vue?vue&type=script&lang=js"
export * from "./CreateStoryButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports